<input
  data-e2e="input-field"
  class="form-control rounded-sm"
  [ngClass]="{
    'input-with-icon-padding-left': icon && iconPlacement === 'left',
    'pr-5': icon && iconPlacement === 'right'
  }"
  (focus)="onFocus(true)"
  (focusout)="onFocus(false)"
  [formControl]="inputControl"
  [placeholder]="placeholderText"
  [maxlength]="maxLength"
/>
@if (icon) {
<fa-icon
  class="position-absolute pl-2 icon"
  [ngClass]="{
    left: iconPlacement === 'left',
    right: iconPlacement === 'right'
  }"
  [icon]="loading ? ['fas', 'spinner'] : icon"
  [spin]="loading"
  [pulse]="loading"
  size="sm"
></fa-icon>
}
<ng-content></ng-content>
